(function () {
  // mobile menu
  var t = document.querySelector('[data-menu-toggle]'), nav = document.querySelector('[data-nav]');
  if (t && nav) t.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open'); t.setAttribute('aria-expanded', open);
  });

  // hero slider
  document.querySelectorAll('[data-slider]').forEach(function (s) {
    var track = s.querySelector('[data-track]'), slides = track.children, dots = s.querySelector('[data-dots]'), i = 0;
    var prev = s.querySelector('[data-prev]'), next = s.querySelector('[data-next]');
    function go(n) { i = (n + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); mark(); }
    function mark() { if (dots) [].forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', k === i); }); }
    if (dots) for (var k = 0; k < slides.length; k++) (function (k) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (k + 1));
      b.addEventListener('click', function () { go(k); }); dots.appendChild(b);
    })(k);
    mark();
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / track.clientWidth); if (n !== i) { i = n; mark(); }
    }, { passive: true });
    var sec = parseInt(s.getAttribute('data-autoplay'), 10);
    if (sec > 0 && slides.length > 1 && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
      var timer = setInterval(function () { go(i + 1); }, sec * 1000);
      s.addEventListener('mouseenter', function () { clearInterval(timer); });
    }
  });

  // collection sort
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u;
  });

  // product page: variants + thumbnails
  var p = document.querySelector('[data-product]');
  if (p) {
    var variants = JSON.parse(p.querySelector('[data-variants]').textContent);
    var selects = p.querySelectorAll('[data-option]');
    var idInput = p.querySelector('[data-variant-id]');
    var now = p.querySelector('[data-price-now]'), was = p.querySelector('[data-price-was]');
    var add = p.querySelector('[data-add]'), buy = p.querySelector('[data-buy]');
    var fmt = function (c) { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR', maximumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100); };
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var vals = [].map.call(selects, function (x) { return x.value; });
        var v = variants.find(function (x) { return x.options.join('|') === vals.join('|'); });
        if (!v) { add.disabled = buy.disabled = true; add.textContent = 'Unavailable'; return; }
        idInput.value = v.id; now.textContent = fmt(v.price);
        if (v.compare_at_price > v.price) { was.textContent = fmt(v.compare_at_price); was.hidden = false; } else { was.hidden = true; }
        add.disabled = buy.disabled = !v.available; add.textContent = v.available ? 'Add to Cart' : 'Sold out';
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
        if (v.featured_image) { var m = document.getElementById('MainImg'); if (m) { m.removeAttribute('srcset'); m.src = v.featured_image.src; } }
      });
    });
    p.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () { var m = document.getElementById('MainImg'); if (m) { m.removeAttribute('srcset'); m.src = b.getAttribute('data-thumb'); } });
    });
  }
})();
